import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconSettings(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M7 4a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0V7H4a1 1 0 0 1 0-2h3V4ZM11 6a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1ZM3 12a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM17 10v1h3a1 1 0 1 1 0 2h-3v1a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0ZM13 16v1h7a1 1 0 1 1 0 2h-7v1a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0ZM9 18a1 1 0 0 0-1-1H4a1 1 0 1 0 0 2h4a1 1 0 0 0 1-1Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
